/**
 * Simple "Required" check for object keys
 */
export const validateRequiredFields = (values: any, errors: any, keys: string[]) => {
	keys.forEach((key) => {
		if (!values[key] || values[key] === '') {
			errors[key] = 'Required';
		}
	});
};

/**
 * Character limit validator for Formik/UI
 */
export const checkMaxCharacterLength = (values: any, errors: any, checks: { key: string; length: number }[]) => {
	checks.forEach(({ key, length }) => {
		if (values[key] && values[key].length > length) {
			errors[key] = `Max ${length} characters allowed (Current: ${values[key].length})`;
		}
	});
};

export const isValidEmail = (email?: string): boolean => {
	if (!email) return false;
	const regex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regex.test(email.trim().toLowerCase());
};

export const isValidPhone = (phone?: string): boolean => {
	if (!phone) return false;
	const cleaned = phone.replace(/\D/g, '');
	return cleaned.length >= 10 && cleaned.length <= 15;
};

export const areRequired = (values: Record<string, any>, errors: Record<string, string>, keys: Array<string>) => {
	keys.forEach((key) => {
		if (!values[key] || values[key] === null || values[key] === '') errors[key] = 'Required';
		// if (
		//     values[key]?.country === null ||
		//     values[key]?.country === '' ||
		//     key === 'country' && !values[key]?.country ||
		//     JSON.stringify(values[key]?.country) === '{}'
		// ) errors[key] = 'Required';
	});
};

export const maxCharacterLength = (values: any, errors: { [x: string]: string }, checks: any) => {
	for (const check of checks) {
		if (values[check.key] && values[check.key].length > check.length)
			errors[check.key] = `${values[check.key].length} / ${check.length} 
            Max number of characters has reached`;
	}
};

export const infoCheck = (data: { toString: () => { (): any; new (): any; length: number } }) => {
	return data && data.toString().length >= 1 ? data : 'Currently no information';
};

export const validateEmail = (_email: string) => {
	const emailRegex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	if (!_email) return false;
	const email = _email.trim().toLowerCase();
	return emailRegex.test(email);
};

export const validatePhoneNumber = (phone: string): boolean => {
	const cleaned = phone.replace(/\D/g, '');
	const phoneRegex = /^[0-9]{10,15}$/;
	return phoneRegex.test(cleaned);
};
